import React from 'react';
import {
  Html,
  Head,
  Body,
  Container,
  Section,
  Text,
  Hr,
  Tailwind,
  pixelBasedPreset,
  Markdown,
} from '@react-email/components';

interface SCNTemplateEmailBodyProps {
  content: string;
  signature: string;
  footerNotice: string;
}

export const SCNEmailBodyTemplate: React.FC<SCNTemplateEmailBodyProps> = ({
  content,
  signature,
  footerNotice
}) => {
  return (
    <Html>
      <Head />
      <Tailwind
        config={{
          presets: [pixelBasedPreset],
          theme: {
            extend: {
              colors: {
                brand: '#c53030',
                warning: '#fed7d7',
                text: '#333333',
                muted: '#718096',
              },
              spacing: {
                0: '0px',
                16: '16px',
                20: '20px',
                24: '24px',
                32: '32px',
                40: '40px',
              },
            },
          },
        }}
      >
        <Body className="bg-white font-sans text-base text-text">
          <Container className="mx-auto max-w-2xl px-20 py-40">
            
            {/* Important Notice Header */}
            <Section className="mb-32">
              <div className="rounded-lg border-2 border-red-500 bg-warning p-16 text-center">
                <Text className="m-0 text-lg font-bold text-brand">
                  ⚠️ IMPORTANT SHOW CAUSE NOTICE
                </Text>
              </div>
            </Section>

            {/* Main Content */}
            <Section className="mb-40">
              <Markdown>{content}</Markdown>
            </Section>

            {/* Signature Section */}
            <Section className="mb-32">
              <Text className="text-base leading-6 text-text whitespace-pre-wrap">
                {signature}
              </Text>
            </Section>

            {/* Divider */}
            <Hr className="my-32 border-gray-300" />
            
            {/* Legal Disclaimer */}
            <Section>
              <Text className="text-xs leading-5 text-muted whitespace-pre-wrap">
                {footerNotice}
              </Text>
            </Section>

          </Container>
        </Body>
      </Tailwind>
    </Html>
  );
};

export default SCNEmailBodyTemplate;
